export const addMemberFormField = [
	{
		type: 'hidden',
		formControlName: 'id',
	},
	{
		type: 'text',
		title: 'Name (character limit 200)',
		placeholder: 'Enter Name',
		formControlName: 'name',
		required: true,
		maxLength: 200,
		errorsMsg: [
			{ type: 'required', message: 'Name is required' },
			{
				type: 'maxlength',
				message: 'Name should be less than 200 characters',
			},
		],
	},
	{
		type: 'email',
		title: 'Email',
		placeholder: 'Enter Email',
		formControlName: 'email',
		required: true,
		maxLength: 100,
		errorsMsg: [
			{ type: 'required', message: 'Email is required' },
			{
				type: 'pattern',
				message: 'Enter valid email',
			},
		],
	},
];
